// extracted by mini-css-extract-plugin
export default {"layout":"Avatar_layout__ifWm7","active":"Avatar_active__kP0SZ","username":"Avatar_username__Kirxa","icon":"Avatar_icon__yo+a7"};